import StudioFeatureCard from "@components/BasicComponents/Cards/StudioFeatureCard/StudioFeatureCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ButtonComponent from "@components/Theme/Button/Button"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

// import styles from "./ThirdPartySection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const ThirdPartySection = (props: Props) => {
	const data = props.data?.mainContent

	return (
		<section style={{overflow: "hidden", background: "#f5f5f5"}}>
			<Separator size={128}>
				<ContainerWrapper>
					<Title
						content={props.data.sectionTitle}
						fontWeight={600}
						size={"XL"}
						center
					/>

					<Separator />
					{data?.map(
						(
							element: AdvancedSideAssetMainContent,
							index: number,
						) => {
							return (
								<React.Fragment key={index}>
									<StudioFeatureCard
										data={element}
										direction={"right"}
									/>
									{index + 1 < data.length && (
										<Separator size={128} />
									)}
								</React.Fragment>
							)
						},
					)}
					<Separator />
					<Separator textAlignCenter withoutMeasure>
						<ButtonComponent
							buttonType={"secondary"}
							link={props.data.sectionBottomButtonLink}
							asLink
						>
							{props.data.sectionBottomButton}
						</ButtonComponent>
					</Separator>
				</ContainerWrapper>
			</Separator>
		</section>
	)
}

export default ThirdPartySection
